module.exports = __webpack_public_path__ + "static/media/HOW TO ADD A CLIENT PARTNER.a5cac2c1.png";